import { PhotoBoothComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import PhotoBooth from '../PhotoBooth';

const PhotoBoothUiComponent = ({ uiComponent }: UiComponentElementInterface<PhotoBoothComponentInterface>) => {
  return (
    <div
      className={`wrapper w-full overflow-hidden`}
      style={{
        color: uiComponent?.styling?.textColor || '#000',
      }}>
      <PhotoBooth component={uiComponent!} />
    </div>
  );
};

export default PhotoBoothUiComponent;
